var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.114 14.572h-.812l-.288-.278a6.656 6.656 0 001.614-4.351 6.685 6.685 0 10-6.685 6.686 6.656 6.656 0 004.35-1.615l.278.288v.813l5.143 5.132 1.533-1.532-5.133-5.143zm-6.171 0a4.622 4.622 0 01-4.629-4.629 4.622 4.622 0 014.629-4.629 4.622 4.622 0 014.628 4.629 4.622 4.622 0 01-4.628 4.629z",
    fill: "#fff"
  })));
}
export default SvgSearch;